export class ValidationPatterns {
  /**
   * Pattern for email validation
   */
  public static readonly email =
    /^(([^<>()\[\]\\.,'`"|!%=+?&*^$#/;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  /**
   * Pattern for validating a Betterix email address.
   * This pattern allows for email addresses that contain a variety of special characters in the local part (before the '@' symbol), and allows for subdomains in the domain part (after the '@' symbol).
   */
  public static readonly betterixEmail =
    /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~](?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{0,63}[a-zA-Z0-9!#$%&'*+/=?^_`{|}~])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+\.*$/;

  /**
   * Pattern for phone number validation
   */
  public static readonly phoneNumber = /(^[+]?[0-9]+)$/;

  /**
   * Pattern for cvv validation
   */
  public static readonly cvv = /^[0-9]{3,4}$/;

  /**
   * Pattern only numbers
   */
  public static readonly numbers = '^[0-9]*$';

  /**
   * Pattern only letters
   */
  public static readonly letters = /^[A-Za-z]+$/;

  /**
   * Pattern for creditCard validation
   */
  public static readonly creditCard =
    /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;

  /**
   * Pattern for date of birth validation
   */
  public static readonly dateOfBirth = /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19(18|19|[2-9][0-9])|20\d\d)$/;

  /**
   * Pattern for all languages letters and numbers without spaces
   */
  public static readonly lettersAndNumbers =
    /^[一-龠ぁ-ゔァ-ヴーA-Za-zwàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð0-9]+$/;

  public static readonly expiryDate = /^(0[1-9]|1[0-2])\s*\/\s*\d{2}$/;

  public static readonly iban = /^[A-Z]{2}\d{2}[A-Z0-9]{0,35}$/;

  public static readonly zip = /^(?!.*--)(?!-)(?!.*-$)[A-Z0-9 -]+$/;

  public static readonly firsLastName = /^[A-Za-z\s'\-.]+$/;

  // Use for country, address, street, state
  public static readonly cityAddress = /^(?! )[\p{L}\p{N}\-\.'&,_#()*/\\\^]+(?:[ '-][\p{L}\p{N}\-\.'&,_#()*/\\\^]+)*(?<! )$/u;
}
